export const MAX_POST_MEDIA_FILES = 10;
export const MAX_POST_IMAGE_SIZE = 20 * 1024 * 1024;
export const MAX_POST_VIDEO_SIZE = 100 * 1024 * 1024;

export const getPostMediaKind = file => {
  if (file?.type?.startsWith('image/')) return 'image';
  if (file?.type?.startsWith('video/')) return 'video';
  return null;
};

export const getPostMediaCount = values =>
  ['image', 'video', 'gifs'].reduce(
    (total, key) => total + (Array.isArray(values?.[key]) ? values[key].length : 0),
    0
  );

const formatMegabytes = bytes => Math.round(bytes / (1024 * 1024));

export const validatePostMediaFiles = ({
  files,
  existingCount = 0,
  allowedKinds = ['image', 'video'],
}) => {
  const selectedFiles = Array.from(files || []);
  const availableSlots = Math.max(MAX_POST_MEDIA_FILES - existingCount, 0);
  const acceptedFiles = [];
  const errors = [];

  selectedFiles.forEach(file => {
    const kind = getPostMediaKind(file);
    if (!kind || !allowedKinds.includes(kind)) {
      errors.push(`${file.name}: only ${allowedKinds.join(' or ')} files are supported.`);
      return;
    }

    const sizeLimit = kind === 'image' ? MAX_POST_IMAGE_SIZE : MAX_POST_VIDEO_SIZE;
    if (file.size > sizeLimit) {
      errors.push(`${file.name}: maximum ${kind} size is ${formatMegabytes(sizeLimit)} MB.`);
      return;
    }

    if (acceptedFiles.length >= availableSlots) {
      return;
    }

    acceptedFiles.push(file);
  });

  const validSelectionCount = selectedFiles.filter(file => {
    const kind = getPostMediaKind(file);
    if (!kind || !allowedKinds.includes(kind)) return false;
    const sizeLimit = kind === 'image' ? MAX_POST_IMAGE_SIZE : MAX_POST_VIDEO_SIZE;
    return file.size <= sizeLimit;
  }).length;
  const filesOverCountLimit = Math.max(validSelectionCount - availableSlots, 0);

  if (filesOverCountLimit > 0 || (selectedFiles.length > 0 && availableSlots === 0)) {
    errors.push(
      `You can attach up to ${MAX_POST_MEDIA_FILES} photos or videos per post. ${
        filesOverCountLimit || selectedFiles.length
      } file(s) were not added.`
    );
  }

  return { acceptedFiles, errors };
};
